<template>
  <component 
    :is="tag"
    :class="labelFont" 
  >
    <span class="d-inline-block" :class="labelTextClass">{{label}}</span>
    <FormHint class="d-inline-block ml-3" v-if="labelHint" :label="labelHint" />
    <IconHelp class="d-inline-block ml-3" v-if="labelHelp" :message="labelHelp" />
    <FormRequired class="d-inline-block ml-3" v-if="labelRequired" />
  </component>
</template>

<script>
import FormHint from "@components_system/Shared/Elements/Texts/FormHint";
import FormRequired from "@components_system/Shared/Elements/Texts/FormRequired";
import IconHelp from "@components_system/Shared/Elements/IconHelp/IconHelp";

export default {
  components: {
    FormHint,
    FormRequired,
    IconHelp,
  },
  props: {
    tag: {
      type: String,
      default: "label",
    },
    label: {
      type: String,
      default: "",
    },
    labelFont: {
      type: String,
      default: "fs-sa-14",
    },
    labelTextClass: {
      type: String,
      default: undefined,
    },
    labelHint: {
      type: String,
      default: undefined, // Ex. (Hover)
    },
    labelHelp: {
      type: String,
      default: undefined, // Ex. message
    },
    labelRequired: {
      type: Boolean,
      default: false,
    },
  },
};
</script>